<div class="multiple-auth-list">
  <div class="bz-space--inline-s" *ngIf="viewMode !== 1">
    <div class="multiple-auth-list__head-add-button bz-space--stack-m">
      <bzg-button-primary [disabled]="!isEditable" (click)="addAuthenticator()">
        <svg class="bz-icon-svg bz-icon-svg--16">
          <use href="#icon-plus"></use>
        </svg>
        {{ 'AUTHENTICATION.ADD_AUTHENTICATOR' | translate }}
      </bzg-button-primary>
    </div>
    <div class="bz-divider bz-divider--horizontal bz-space--stack-m"></div>
    <div class="multiple-auth-list__head-title">
      <span class="multiple-auth-list__head-title-content">{{ 'AUTHENTICATION.AUTHENTICATOR_LIST' | translate }}</span>
      <bzg-icon *ngIf="!deleteActivated && isEditable" class="multiple-auth-list__head-title-icon" [nameIcon]="'icon-delete'"
        [size]="16" (click)="deleteActivated = true">
      </bzg-icon>
      <div *ngIf="deleteActivated" class="multiple-auth-list__delete-buttons">
        <bzg-button-secondary class="bz-space--inline-s" [size]="'s'" (click)="cancelDeletion()">
          {{'GLOBAL.CANCEL' | translate}}</bzg-button-secondary>
        <bzg-button-secondary [icon]="'icon-delete'" [size]="'s'" (click)="showDeleteConfirmation()"
          [disabled]="deletionArray.length === 0">
          {{'GLOBAL.DELETE' | translate}}
        </bzg-button-secondary>
      </div>
    </div>
    <div class="multiple-auth-list__search-box bz-space--stack-m">
      <bzg-input [placeholder]="('AUTHENTICATION.SEARCH_BY' | translate) + '...'"
        class="multiple-auth-list__search-box__text" name="search-box" [(ngModel)]="searchValue"
        actionIcnPosition="right">
        <bzg-icon nameIcon="icon-search"></bzg-icon>
      </bzg-input>
    </div>
  </div>
  <ul class="multiple-auth-list__items multiple-auth-list__items--scroll" *ngIf="unSelectListStatus === 'active' && viewMode === 2"
    [@slideListUnselect]="unSelectListStatus" (@slideListUnselect.done)="emitAfterAnimation($event)">
    <ng-container *ngIf="authenticatorList && (viewMode === 0 || viewMode === 2)">
      <li
        *ngFor="let authenticator of authenticatorList.authenticators | searchBy : searchValue : ['displayName']"
        class="multiple-auth-list__item bz-space--inset-squish-m bz-space--stack-s bz-space--inline-s bz-shadow--xs bz-border-radius--m"
        [ngClass]="{'bz-color-bg--theme-100': ((!!selectedConnector && (selectedConnector.name === connector.name)) && !deleteActivated),
        'multiple-auth-list__item--disabled': isDisabled(authenticator),
        'multiple-auth-list__item--enabled': !isDisabled(authenticator)}"
        (click)="setSelectedAuthenticator(authenticator, $event)">
        <div class="multiple-auth-list__item__content-top">
          <bzg-checkbox (click)="$event.stopPropagation()" *ngIf="deleteActivated"
          (change)="addOrRemoveFromDeletionList(authenticator, $event)"></bzg-checkbox>
          <div class="multiple-auth-list__item__texts"
            [ngClass]="{'multiple-auth-list__item__texts--on-delete': deleteActivated}">
            <h5 class="bz-font-weight--semibold" [ngClass]="{'bz-space--stack-s': (true)}">
              {{ authenticator.displayName || authenticator.type }}</h5>
            <span>{{ authenticator.type }}</span>
          </div>

          <svg class="bz-icn bz-icon-svg--24 multiple-auth-list__item__disabled-icon" *ngIf="isDisabled(authenticator)"
          [bzgTooltip]="('AUTHENTICATION.ICON_WARNING_AUTHENTICATOR_ERROR' | translate)" bzgTooltipPosition="above">
            <use href="#icon-warning"></use>
          </svg>

          <svg class="bz-icn bz-icon-svg--16 multiple-auth-list__item__arrow-icon">
            <use href="#icon-arrow-right-bold"></use>
          </svg>
        </div>
        <div class="multiple-auth-list__item__content-bottom">
          <div class="multiple-auth-list__item__text-warning" *ngIf="isDisabled(authenticator)">
            <a href="http://help.bizagi.com/automation-service/en/cloud_authentication.htm">
              {{'AUTHENTICATION.URL_AUTHENTICATOR_ERROR' | translate}} http://help.bizagi.com/automation-service/en/cloud_authentication.htm
            </a>
          </div>
        </div>
      </li>
    </ng-container>
  </ul>
  <ul class="multiple-auth-list__items" *ngIf="authenticatorList && (viewMode === 1)"
    [@slideListSelect] (@slideListSelect.done)="showListAfterAnimation($event)">
    <li
      class="multiple-auth-list__item multiple-auth-list__item--selected bz-space--inset-squish-m bz-space--stack-s bz-space--inline-s bz-shadow--xs bz-border-radius--m"
      [ngClass]="{'bz-color-bg--theme-100': (!!currentAuthenticator), 'multiple-auth-list__item--on-delete': false}"
      (click)="setSelectedAuthenticator(currentAuthenticator, $event)">
      <div class="multiple-auth-list__item__content-top">
        <svg class="bz-icn bz-icon-svg--16 bz-space--inline-m multiple-auth-list__item__arrow-icon" (click)="changeToUnselectMode()">
          <use href="#icon-arrow-left-bold"></use>
        </svg>
        <div class="multiple-auth-list__item__texts" [ngClass]="{'multiple-auth-list__item__texts--on-delete': false}">
          <h5 class="bz-font-weight--semibold" [ngClass]="{'bz-space--stack-s': (true)}">{{ currentAuthenticator.displayName }}</h5>
          <span>{{ currentAuthenticator.type }}</span>
        </div>
      </div>
    </li>
    <biz-security-auth-list class="multiple-auth-list__options-list" [showTitle]="false" [showSearchBox]="true"
      [selectedMethod]="currentAuthenticator" [methodType]="currentAuthenticator.type" [selectedFlow]="selectedFlow"
      [selectedMetadata]="selectedOptionsMetadata" (onSelectOption)="selectOption($event)" [isDisabled]="isDisabled()"
      (onSelectOAuthOption)="selectOAuthOption($event)">
    </biz-security-auth-list>
  </ul>
</div>
